export const STAGES = [
  { key: "applied", label: "Applied" },
  { key: "shortlisted", label: "Shortlisted" },
  { key: "phone_screen", label: "Phone Screen" },
  { key: "interview", label: "Interview" },
  { key: "offer", label: "Offer" },
  { key: "onboarding", label: "Onboarding" },
  { key: "hired", label: "Hired" },
  { key: "rejected", label: "Rejected" },
];

export const STAGE_MAP = Object.fromEntries(STAGES.map((s) => [s.key, s.label]));

export const stagePillClass = (stage) => {
  switch (stage) {
    case "applied": return "pill-neutral";
    case "shortlisted": return "pill-info";
    case "phone_screen": return "pill-info";
    case "interview": return "pill-sage";
    case "offer": return "pill-warning";
    case "onboarding": return "pill-warning";
    case "hired": return "pill-success";
    case "rejected": return "pill-danger";
    default: return "pill-neutral";
  }
};

export const dbsPillClass = (status) => {
  switch (status) {
    case "clear": return "pill-success";
    case "received": return "pill-sage";
    case "in_progress": return "pill-warning";
    case "sent": return "pill-info";
    case "not_clear": return "pill-danger";
    default: return "pill-neutral";
  }
};

export const refsPillClass = (status) => {
  switch (status) {
    case "verified": return "pill-success";
    case "received": return "pill-sage";
    case "awaiting": return "pill-warning";
    case "flagged": return "pill-danger";
    default: return "pill-neutral";
  }
};

export const rtwPillClass = (status) => {
  switch (status) {
    case "verified": return "pill-success";
    case "in_progress": return "pill-warning";
    case "rejected": return "pill-danger";
    default: return "pill-neutral";
  }
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

export const daysUntil = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  return Math.ceil((d - new Date()) / (1000 * 60 * 60 * 24));
};

export const initials = (first = "", last = "") => `${first[0] || ""}${last[0] || ""}`.toUpperCase();

export const roleLabel = (role) => {
  const map = {
    hr_admin: "HR Admin",
    recruiter: "Recruiter",
    interviewer: "Interviewer",
    nominated_individual: "Nominated Individual",
    finance: "Finance",
  };
  return map[role] || role;
};
